<template>
  <div class="hello" style="height: 100vh;" v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.8)">
    <GlobalHeader style="position: absolute;" :activeIndex="activeIndex"/>
    <el-main>
      <div style="position: fixed;z-index: 111; background: #fff;width: calc(100% - 175px); min-width:1200px">
        <div class="edit">
          <div class="fl" style="justify-content: space-between; margin-left: 6px;">
            <span class="upload-btn" @click="uploadEvt" @mouseenter="changeImg('enter')"
                  @mouseleave="changeImg('leave')">
              <!-- 用v-bind:src（简写:src）动态绑定图片路径 -->
              <img
                  :src="imgUrl"
                  style="width: 15px; height: 15px"
                  alt="上传图标"
              />
            </span>
          </div>
          <div @click="dialogVisible_one = true"
               class="filter-btn">
            <span style="font-size: 14px;">filter</span>
          </div>
          <!-- 1. 项目名称 -->
          <el-tooltip class="item" effect="dark" content="项目名称" placement="bottom" v-if="shouldShowItem('name')">
            <el-input
                placeholder="项目名称"
                v-model="name"
                suffix-icon="el-icon-caret-bottom"
                clearable
                @change="getList"
                @focus="focusDiyIptEvt"
                style="width: 137px;"
                :class="{ 'vip': name && name.length !== 0 }">
            </el-input>
          </el-tooltip>

          <!-- 2. 客户名称 -->
          <el-tooltip class="item" effect="dark" content="客户名称" placement="bottom"
                      v-if="shouldShowItem('customer')">
            <el-input
                placeholder="客户名称"
                v-model="customer"
                suffix-icon="el-icon-caret-bottom"
                clearable
                @change="getList"
                @focus="focusDiyIptEvt"
                v-if="userRole != 5"
                style="width: 137px;"
                :class="{ 'vip': customer && customer.length !== 0 }">
            </el-input>
          </el-tooltip>

          <!-- 3. 项目经理 -->
          <el-tooltip class="item" effect="dark" content="项目经理" placement="bottom" v-if="shouldShowItem('charge')">
            <el-select
                v-model="charge"
                filterable
                placeholder="项目经理"
                @change="chargeChange"
                style="margin-left: 6px;"
                clearable
                :class="{ 'vip': charge && charge !== '项目经理' }">
              <el-option v-for="(item, index) in charge_id" :key="index" :label="item.name"
                         :value="item.id"></el-option>
            </el-select>
          </el-tooltip>

          <!-- 4. 签单人 -->
          <el-tooltip class="item" effect="dark" content="签单人" placement="bottom" v-if="shouldShowItem('sign')">
            <el-select
                v-model="sign"
                filterable
                placeholder="签单人"
                @change="signChange"
                style="margin-left: 6px;"
                clearable
                :class="{ 'vip': sign && sign !== '签单人' }"
                v-if="userRole != 5">
              <el-option v-for="(item, index) in set_of" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-tooltip>

          <!-- 5. 维护人 -->
          <el-tooltip class="item" effect="dark" content="维护人" placement="bottom" v-if="shouldShowItem('assistant')">
            <el-select
                v-model="assistant"
                filterable
                placeholder="维护人"
                @change="assistantChange"
                v-if="userRole != 5"
                style="margin-left: 6px;"
                clearable
                :class="{ 'vip': assistant && assistant !== '维护人' }">
              <el-option v-for="(item, index) in assistant_id" :key="index" :label="item.name"
                         :value="item.id"></el-option>
            </el-select>
          </el-tooltip>

          <!-- 6. 开工时间（替换原有v-if） -->
          <el-tooltip class="item" effect="dark" content="开工时间" placement="bottom" v-if="shouldShowItem('value3')">
            <el-date-picker
                v-model="value3"
                style="width: 137px;margin-left: 6px;"
                type="daterange"
                @change="getList"
                @clear="clearValue3"
                :picker-options="pickerOptions"
                size="mini"
                format="yyyy-MM-dd"
                range-separator=""
                class="border_box"
                start-placeholder="开工时间"
                align="right"
                value-format="timestamp"
                :class="{ 'your-css-class': hasValue3 }">
            </el-date-picker>
          </el-tooltip>

          <!-- 7. 要求时间（替换原有v-if） -->
          <el-tooltip class="item" effect="dark" content="要求时间" placement="bottom" v-if="shouldShowItem('value4')">
            <el-date-picker
                v-model="value4"
                style="width: 137px;margin-left: 6px;"
                type="daterange"
                @change="getList"
                :picker-options="pickerOptions"
                size="mini"
                format="yyyy-MM-dd"
                range-separator=""
                class="border_box"
                clearable
                start-placeholder="要求时间"
                align="right"
                value-format="timestamp"
                :class="{ 'your-css-class': hasValue4 }">
            </el-date-picker>
          </el-tooltip>

          <!-- 8. 实际完工（替换原有v-if） -->
          <el-tooltip class="item" effect="dark" content="实际完工" placement="bottom" v-if="shouldShowItem('value1')">
            <el-date-picker
                v-model="value1"
                style="width: 137px;margin-left: 6px;"
                type="daterange"
                @change="getList"
                :picker-options="pickerOptions"
                size="mini"
                format="yyyy-MM-dd"
                range-separator=""
                class="border_box"
                clearable
                start-placeholder="实际完工"
                align="right"
                value-format="timestamp"
                :class="{ 'your-css-class': hasValue1 }">
            </el-date-picker>
          </el-tooltip>

          <!-- 9. 上传时间（替换原有v-if） -->
          <el-tooltip class="item" effect="dark" content="上传时间" placement="bottom" v-if="shouldShowItem('value2')">
            <el-date-picker
                v-model="value2"
                style="width: 137px;margin-left: 6px;"
                type="daterange"
                @change="getList"
                :picker-options="pickerOptions"
                size="mini"
                format="yyyy-MM-dd"
                range-separator=""
                class="border_box"
                start-placeholder="上传时间"
                align="right"
                value-format="timestamp"
                :class="{ 'your-css-class': hasValue2 }">
            </el-date-picker>
          </el-tooltip>

          <!-- 10. 评图时间（替换原有v-if） -->
          <el-tooltip class="item" effect="dark" content="评图时间" placement="bottom"
                      v-if="shouldShowItem('score_time_one')">
            <el-date-picker
                v-model="score_time_one"
                style="width: 137px;margin-left: 6px;"
                type="daterange"
                @change="getList"
                :picker-options="pickerOptions"
                size="mini"
                format="yyyy-MM-dd"
                range-separator=""
                class="border_box"
                start-placeholder="评图时间"
                align="right"
                value-format="timestamp"
                :class="{ 'your-css-class': hasValue0 }">
            </el-date-picker>
          </el-tooltip>

          <!-- 11. 制作人 -->
          <el-tooltip class="item" effect="dark" content="制作人" placement="bottom" v-if="shouldShowItem('make')">
            <el-select
                v-model="make"
                filterable
                placeholder="制作人"
                @change="makeChange"
                style="margin-left: 6px;"
                clearable
                :class="{ 'vip': make && make !== '制作人' }">
              <el-option v-for="(item, index) in make_one" :key="index" :label="item.name"
                         :value="item.staff_id"></el-option>
            </el-select>
          </el-tooltip>

          <!-- 12. 备注 -->
          <el-tooltip class="item" effect="dark" content="备注" placement="bottom"
                      v-if="shouldShowItem('content_remark')">
            <el-input
                placeholder="备注"
                v-model="content_remark"
                @change="getList"
                @focus="focusDiyIptEvt"
                suffix-icon="el-icon-caret-bottom"
                clearable
                v-if="userRole != 5"
                style="width: 137px;"
                :class="{ 'vip': content_remark && content_remark.length !== 0 }">
            </el-input>
          </el-tooltip>

          <!-- 13. 评图状态 -->
          <el-tooltip class="item" effect="dark" content="评图状态" placement="bottom" v-if="shouldShowItem('design')">
            <el-select
                v-model="design"
                filterable
                placeholder="评图状态"
                @change="getList"
                style="margin-left: 6px;"
                clearable
                :class="{ 'vip': design && design !== '评图状态' }">
              <el-option v-for="(option, index) in options1" :key="index" :label="option.label"
                         :value="option.value"></el-option>
            </el-select>
          </el-tooltip>

          <!-- 14. 角度 -->
          <el-select
              filterable
              style="margin-left: 6px;"
              clearable
              v-if="shouldShowItem('angleValue')"
              v-model="angleValue"
              @change="handleAngleChange"
              :class="{ 'vip': angleValue && angleValue !== '角度' }">
            <el-option v-for="(item, index) in tag_evt[0].children" :key="index" :label="item.name"
                       :value="item.id"></el-option>
          </el-select>

          <!-- 15. 景别 -->
          <el-select
              filterable
              style="margin-left: 6px;"
              clearable
              v-if="shouldShowItem('viewValue')"
              v-model="viewValue"
              @change="handleViewChange"
              :class="{ 'vip': viewValue && viewValue !== '景别' }">
            <el-option v-for="(item, index) in tag_evt[1].children" :key="index" :label="item.name"
                       :value="item.id"></el-option>
          </el-select>
          <!-- 16. 室内类别 -->
          <el-select
              filterable
              style="margin-left: 6px;"
              clearable
              v-if="shouldShowItem('indoorTypeValue')"
              v-model="indoorTypeValue"
              @change="handleIndoorTypeChange"
              :class="{ 'vip': indoorTypeValue && indoorTypeValue !== '室内类别' }">
            <el-option
                v-for="(item, index) in tag_evt[2].children"
                :key="index"
                :label="item.name"
                :value="item.id">
            </el-option>
          </el-select>

          <!-- 17. 建筑类别 -->
          <el-select
              filterable
              style="margin-left: 6px;"
              clearable
              v-if="shouldShowItem('buildingTypeValue')"
              v-model="buildingTypeValue"
              @change="handleBuildingTypeChange"
              :class="{ 'vip': buildingTypeValue && buildingTypeValue !== '建筑类别' }">
            <el-option
                v-for="(item, index) in tag_evt[3].children"
                :key="index"
                :label="item.name"
                :value="item.id">
            </el-option>
          </el-select>

          <!-- 18. 项目区域 -->
          <el-select
              filterable
              style="margin-left: 6px;"
              clearable
              v-if="shouldShowItem('projectAreaValue')"
              v-model="projectAreaValue"
              @change="handleProjectAreaChange"
              :class="{ 'vip': projectAreaValue && projectAreaValue !== '项目区域' }">
            <el-option
                v-for="(item, index) in tag_evt[4].children"
                :key="index"
                :label="item.name"
                :value="item.id">
            </el-option>
          </el-select>

          <!-- 19. 评分 -->
          <el-select
              v-model="score"
              placeholder="评分"
              v-if="shouldShowItem('score')"
              clearable
              collapse-tags
              multiple
              style="width: 180px; margin-left: 6px;"
              @change="getList"
              class="tga_score"
              :class="{ 'vip': score && score.length > 0 }">
            <el-option label="非常好 4.5分以上" value="1"></el-option>
            <el-option label="很好 4.0分以上" value="2"></el-option>
            <el-option label="正常图 3.0-4.0之间" value="3"></el-option>
            <el-option label="差图 3.0分之下" value="4"></el-option>
          </el-select>

          <span style="width: 69px;margin-left:5px;border: 1px solid  #589ff9;" @click="cloneEvt"
                v-if="hasContent">ALL</span>
          <el-switch v-model="switch_e" @change="switch_evt" style="margin-left: 10px;"
                     v-if="userRole == 6 || userRole == 8">
          </el-switch>

        </div>
        <div style="width:100%;">
          <div class="view_box">
            <div class=" fr12  fl">
              <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage1"
                             :page-size="paginationInput - 0" layout="prev, pager, next, jumper" :total="total"
                             :pager-count="5">
              </el-pagination>

              <div type="primary" @click="uploadEvt" class="shangchuan">上传素材</div>
              <div type="primary" @click="ClonaEvt" class="shangchuan">刪除</div>

              <el-dropdown @command="sortEvt">
                <span class="el-dropdown-link" :hide-on-click="false" style="cursor:pointer">
                  {{ sortName }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="1">上传时间-升序</el-dropdown-item>
                  <el-dropdown-item command="1-1">上传时间-降序</el-dropdown-item>
                  <el-dropdown-item command="2">项目开工时间-升序</el-dropdown-item>
                  <el-dropdown-item command="2-1">项目开工时间-降序</el-dropdown-item>
                  <el-dropdown-item command="3">项目完工时间-升序</el-dropdown-item>
                  <el-dropdown-item command="3-1">项目完工时间-降序</el-dropdown-item>
                  <el-dropdown-item command="4">文件尺寸-升序</el-dropdown-item>
                  <el-dropdown-item command="4-1">文件尺寸-降序</el-dropdown-item>
                  <el-dropdown-item command="5">评分-升序</el-dropdown-item>
                  <el-dropdown-item command="5-1">评分-降序</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <div>
                <img v-if="changing == 1" style="
                                width: 20px;
                                height: 20px;
                                line-height: 20px;
                                position: relative;
                                top: 5px;
                              " src="../../images/1.png"/>
                <img v-else style="
                                width: 20px;
                                height: 20px;
                                cursor: pointer;
                                position: relative;
                                top: 5px;
                              " @click="changingEvt(1)" src="../../images/2.png"/>
                <img v-if="changing == 2" style="width: 20px; height: 20px; position: relative; top: 5px"
                     src="../../images/4.png"/>
                <img v-else style="
                                width: 20px;
                                height: 20px;
                                cursor: pointer;
                                position: relative;
                                top: 5px;
                              " @click="changingEvt(2)" src="../../images/3.png"/>
                <img v-if="changing == 3" style="width: 15px; height: 15px; position: relative; top: 3px"
                     src="../../images/03.png"/>
                <img v-else style="width: 15px; height: 15px; cursor: pointer; position: relative; top: 3px"
                     @click="changingEvt(3)" src="../../images/03-1.png"/>

                <img v-if="changing == 4" style="width: 15px; height: 15px; position: relative; top: 3px"
                     src="../../images/02.png"/>
                <img v-else style="width: 15px; height: 15px; cursor: pointer; position: relative; top: 3px"
                     @click="changingEvt(4)" src="../../images/02-1.png"/>
              </div>
            </div>
          </div>
          <div class="content" v-if="changing == 1 || changing == 2">
            <el-scrollbar>
              <div class="img-box">
                <div class="flex-images" @scroll="imgScrollEvt">
                  <div class="item_one" v-for="(e, index) in imgArr" :key="index" v-if="changing ==1"
                       style="width: 360px;height: 280px;" @mousemove="mousemoveEvt(e)" @mouseout="mouseoutEvt"
                       @contextmenu.prevent="rightClickEvt()">
                    <div class="img_one">
                      <img :src="e.thumb" alt="" @click.stop="imgEvt(e,index)"
                           style="width: 100%; height: 220px; object-fit: cover; background-color: #e5e5e5;">
                      <span class="right_top"></span>
                      <div v-if="userRole == 6">
                        <div v-if="switch_e == true ? true : false">
                          <span class="left_top" v-if="e.p == 1"></span>
                          <span class="left_top_2" v-if="e.p == 2"></span>
                          <span class="left_top_3" v-if="e.p == 3"></span>
                        </div>
                      </div>
                      <!-- <span class="right_bottom"></span> -->
                      <div style="display: flex;width: 100%;">
                        <span class="hover-text" style="font-weight: 600;width: 320px;"
                              @click="gather(e,1)">{{ e.project_name }}</span>
                        <span
                            class="hover-text"
                            style="font-size: 13px;color: rgb(129, 124, 124);margin-right: 10px;width:50px;font-weight: 600;text-align: right;"
                            :style="{ color: e.average === '0' ? '#f00' : '#fbfbfb'}">{{
                            e.average
                          }}</span>
                      </div>


                      <div style="display: flex;width: 100%;justify-content: space-around;">
                        <span class="hover-text" style="width: 300px;overflow: hidden;height: 20px" v-if="userRole != 5"
                              @click="gather(e,2)">{{
                            e.customer
                          }}</span>
                        <span
                            class="hover-text"
                            style="font-size: 12px; color: #817c7c;float: right;margin-right: 10px;width:50px;text-align: right;"
                            @click="gather(e,3)">{{
                            e.staff
                          }}</span>
                      </div>

                      <div class="select" :style="{ display: (switch_e && e.select) ? 'block' : 'none' }">
                        <i class="el-icon-check"></i>
                      </div>
                    </div>
                  </div>
                  <div class="item" v-for="(e, index) in imgArr" :key="index" v-if="changing == 2 "
                       :data-w=" changing ==2 ?' 503' : 450" style="display:flex;" :data-h="360"
                       @mousemove="mousemoveEvt(e)" @mouseout="mouseoutEvt"
                       @contextmenu.prevent="rightClickEvt(e)">
                    <div style="display: flex;flex-wrap: wrap;align-items: center;  ">
                      <div class="img_two">
                        <img :src="e.thumb" alt="" @click.stop="imgEvt(e,index)">
                        <span class="right_top"></span>
                        <div v-if="userRole == 6">
                          <div v-if="switch_e == true ? true : false">
                            <span class="left_top" v-if="e.p == 1"></span>
                            <span class="left_top_2" v-if="e.p == 2"></span>
                            <span class="left_top_3" v-if="e.p == 3"></span>
                          </div>
                        </div>
                      </div>

                      <div style="display: flex;width: 100%;    justify-content: space-around;">
                        <span class="hover-text" style="font-weight: 600;width:270px;"
                              @click="gather(e,1)">{{ e.project_name }}</span>
                        <span class="hover-text"
                              style="font-size: 13px;color: rgb(129, 124, 124);width:50px;font-weight: 600;text-align: right;margin-left: 5px;">{{
                            e.average
                          }}</span>
                      </div>
                      <div style="display: flex;width: 100%;justify-content: space-around;">

                        <span class="hover-text" style="width: 270px;overflow: hidden;height: 20px" v-if="userRole != 5"
                              @click="gather(e,2)">{{
                            e.customer
                          }}</span>
                        <span class="hover-text"
                              style="font-size: 12px; color: #817c7c;float: right;width:50px;text-align: right;"
                              @click="gather(e,3)">{{
                            e.staff
                          }}</span>
                      </div>
                      <div class="select" :style="{ display: (switch_e && e.select) ? 'block' : 'none' }">
                        <i class="el-icon-check"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-scrollbar>
          </div>
        </div>
      </div>

      <el-dialog :visible.sync="dialogFormVisible" width="23%" custom-class="searchLabel_one" :top="dialogTop"
                 :before-close="clone_eEvt" :show-close="false">
        <div style="display:flex;    justify-content: center;    margin-top: 30px;">
          <div>
            <el-select v-model="project" filterable placeholder="多个项目" @change="projectChange"
                       style="margin-left: 6px;"
                       clearable>
              <el-option v-for="(value, key) in project_one" :key="key" :label="value.name" :value="value.id">
              </el-option>
            </el-select>
            <p style="text-align:left;font-size:11px;text-indent: 10px;height:40px;">{{ customerDisplayText }}</p>
            <div
                style="text-align:left; text-indent: 10px;margin-top:40px;     position: absolute;    top: -15px;left: 40px;">
              已选中 {{ selectArr.length }} 项
            </div>
          </div>
          <el-form :model="form" class="form_one">
            <el-form-item label="制作人" :label-width="formLabelWidth">
              <el-select v-model="staff" placeholder="制作人" @change="staffChange" filterable
                         style="margin-left: 6px;" clearable popper-class="selectEvt" :disabled="userRole == 4">
                <el-option v-for="(value, key) in staff_one" :key="key" :label="value.name" :value="value.id">
                  <div style="display: flex;justify-content: space-between;">
                    <span style="text-align: left;width:90px;">{{ value.name }}</span>
                    <span style=" color: #8492a6; font-size: 13px;text-align: left;width:100px;">{{
                        value.department
                      }}</span>
                    <span style=" color: #8492a6; font-size: 13px;text-align: left;width: 50px;">{{
                        value.status
                      }}</span>
                  </div>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="评图时间" :label-width="formLabelWidth">
              <el-date-picker v-model="score_time" type="date" placeholder="选择日期"
                              style="width: 202px;margin-left: 5px;">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="评图状态" :label-width="formLabelWidth">
              <el-select v-model="type" filterable placeholder="评图状态" @change="typeChange" style="margin-left: 6px;"
                         clearable>
                <el-option v-for="(option, index) in options2" :key="index" :label="option.label" :value="option.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div style="display: flex; gap: 10px;    justify-content: center; margin: 70px 0;" class="tag_one">
          <div
              v-for="(mainItem) in tag_evt"
              :key="mainItem.id"
              class="main-category"
          >
            <div class="category-title_one">{{ mainItem.name }}</div>
            <div
                v-for="(subItem) in mainItem.children"
                :key="subItem.id"
                class="sub-item"
                @click="TogSelection(mainItem.name, subItem.name,subItem.id)"
            >
              <!-- 绿色标记点：用 flex 布局确保不偏移 -->
              <span class="dot_one"
                    :class="{ 
                      active: TogisSelected(mainItem.name, subItem.name, subItem.id),
                      green: isGreenTag(subItem.id),
                      gray: isGrayTag(subItem.id)
                    }"></span>
              <span class="text">{{ subItem.name }}</span>
            </div>
          </div>
        </div>

        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="okEvt">确 定</el-button>
        </div>
      </el-dialog>
      <el-dialog :before-close="tanchuangEvt" title="" :visible.sync="searchLabelDialog" width="1800px"
                 :top="dialogTop_one" :show-close="false"
                 custom-class="searchLabel" :transition="false">
        <div style="width: 100%;height: 800px;" class="img_day">
          <div class="image-container">
            <button class="prev-button" @click="prevImage"></button>
            <div v-if="infoArr.length > 0">
              <!-- 用 infoArr[currentIndex] 直接获取当前图片数据，无需循环 -->
              <div style="display:flex;justify-content: space-between;" class="img_day_header">
                <div style="overflow: hidden; box-sizing: border-box; position: relative;">
                  <img
                      :src="infoArr[currentIndex].url"
                      :style="{ 
                        transform: `scale(${scale}) translate(${x}px, ${y}px)`, 
                        maxWidth: '100%', 
                        maxHeight: '100%',
                        cursor: scale === 1 ? 'zoom-in' : (isDragging ? 'grabbing' : 'grab'),
                        transition: isDragging ? 'none' : 'transform 0.1s ease'
                      }"
                      @mousewheel.prevent="handleMouseWheel"
                      @mousedown="startDrag"
                      @mousemove="handleDrag"
                      @mouseup="endDrag"
                      @mouseleave="endDrag"
                      @dblclick="resetImage"
                      style="height:780px; object-fit:scale-down; background-color: #f2f2f2; max-width: calc(100% - 400px); flex-shrink: 0; position: relative;width:1200px"
                  >
                </div>
                <div style="width: 400px; margin:0 10px; box-sizing: border-box; min-height: 780px;text-align: left;">
                  <div style="width:400px;" class="img_day_bottom">
                    <div style="display:flex;">
                      <el-form :model="form" class="form_evt">
                        <!-- 项目名称下拉框：绑定当前图片的project_name -->
                        <el-form-item label="项目名称" :label-width="formLabelWidth">
                          <div>
                            <el-select
                                v-model="infoArr[currentIndex].project_name"
                                filterable
                                placeholder="项目名称"
                                @change="handleProjectChange"
                                style="margin-left: 6px;width:300px;"
                                clearable
                            >
                              <el-option
                                  v-for="(project, key) in project_one"
                                  :key="key"
                                  :label="project.name"
                                  :value="project.id"
                              ></el-option>
                            </el-select>
                            <span style="font-size:12px;margin-left:10px;height:40px;">{{
                                infoArr[currentIndex].customer
                              }}</span>
                          </div>
                        </el-form-item>

                        <!-- 制作人下拉框：绑定当前图片的staff -->
                        <el-form-item label="制作人" :label-width="formLabelWidth" style="margin-top:40px;">
                          <el-select
                              v-model="infoArr[currentIndex].staff"
                              placeholder="制作人"
                              @change="handleStaffChange"
                              filterable
                              style="margin-left: 6px;width:300px"
                              clearable
                              popper-class="selectEvt"
                              :disabled="userRole == 4"
                          >
                            <el-option
                                v-for="(staff, key) in staff_one"
                                :key="key"
                                :label="staff.name"
                                :value="staff.id"
                            >
                              <div style="display: flex;justify-content: space-between;">
                                <span style="text-align: left;width:90px;">{{ staff.name }}</span>
                                <span style=" color: #8492a6; font-size: 13px;text-align: left;width:100px;">{{
                                    staff.department
                                  }}</span>
                                <span style=" color: #8492a6; font-size: 13px;text-align: left;width: 50px;">{{
                                    staff.status
                                  }}</span>
                              </div>
                            </el-option>
                          </el-select>
                        </el-form-item>

                        <!-- 其他表单元素同理，均绑定 infoArr[currentIndex] 的属性 -->
                        <el-form-item label="评图时间" :label-width="formLabelWidth">
                          <el-date-picker
                              v-model="infoArr[currentIndex].score_time"
                              type="date"
                              placeholder="选择日期"
                              @change="handleReviewTimeChange"
                              style="width:300px;margin-left: 5px;"
                          ></el-date-picker>
                        </el-form-item>

                        <el-form-item label="评图状态" :label-width="formLabelWidth">
                          <el-select
                              v-model="infoArr[currentIndex].is_score"
                              filterable
                              placeholder="评图状态"
                              @change="handleReviewTypeChange"
                              style="margin-left: 6px;width:300px"
                              clearable
                          >
                            <el-option
                                v-for="(option, index) in options2"
                                :key="index"
                                :label="option.label"
                                :value="option.value"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </el-form>
                    </div>

                    <!-- 评分和标签容器：同样绑定当前图片数据 -->
                    <div style="display:flex;margin-left:20px; margin-top:10px;align-items: center;">
                      <span>评分</span>
                      <span style="font-size:26px;margin-left:15px;margin-bottom:10px;">{{
                          infoArr[currentIndex].average
                        }}</span>
                    </div>
                    <div class="tag-container">
                      <div
                          v-for="(mainItem) in tag_evt"
                          :key="mainItem.id"
                          class="main-category">
                        <div class="category-title">{{ mainItem.name }}</div>
                        <div
                            v-for="(subItem) in mainItem.children"
                            :key="subItem.id"
                            class="sub-item"
                            @click="toggleSelection(infoArr[currentIndex], mainItem.name, subItem.name, subItem.id)"
                        >
                          <span class="dot" :class="{ active: isSelected(infoArr[currentIndex], subItem.id) }"></span>
                          <span class="text">{{ subItem.name }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="shanchu"
                       style=" text-align: right; display: flex;justify-content: end; margin-top: 200px; width: 100%;">
                    <div class="button_on" style="margin-right:20px">删除</div>
                    <div class="button_on" style="background:black;color:#fff" @click="download">下载</div>
                  </div>
                </div>
              </div>
            </div>
            <button class="next-button" @click="nextImage"></button>
          </div>
        </div>
      </el-dialog>
    </el-main>
    <el-dialog :visible.sync="dialogVisible_one" width="1400" custom-class="sousuo" :show-close="false">
      <div style="height:360px;">
        <span
            style="width: 69px;border: 1px solid #589ff9;height: 26px;font-size: 12px;line-height: 26px;color: #589ff9;border-radius: 3px;cursor: pointer;display: flex;justify-content: center;margin: 0 40px 30px;"
            @click="cloneEvt">ALL</span>
        <div style="height:300px;display:flex">
          <div>
            <div style="margin-top: 10px;margin-left: 30px;">
              <span>项目名称</span>
              <el-input v-model="name" suffix-icon="el-icon-caret-bottom" clearable @change="getList"
                        @focus="focusDiyIptEvt" style="width: 180px;height: 40px;"
                        :class="{ 'vip': name && name !== '项目名称' }">
              </el-input>
            </div>
            <div
                v-if="userRole != 5 && userRole != 8"
                style="margin-top: 10px;margin-left: 30px;">
              <span>客户名称</span>
              <el-input v-model="customer" suffix-icon="el-icon-caret-bottom" clearable
                        :class="{ 'vip': customer && customer !== '客户名称' }" @change="getList"
                        @focus="focusDiyIptEvt"
                        style="width: 180px;height: 40px;">
              </el-input>
            </div>
          </div>
          <div>

            <div style="margin-top: 10px;margin-left: 30px;">
              <span>签单人</span>
              <el-select v-model="sign" filterable @change="signChange" style="margin-left: 6px;" clearable
                         :class="{ 'vip': sign && sign !== '签单人' }" v-if="userRole != 5">
                <el-option v-for="(item, index) in set_of" :key="index" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div style="margin-top: 10px;margin-left: 30px;">
              <span>维护人</span>
              <el-select v-model="assistant" filterable @change="assistantChange" v-if="userRole != 5"
                         style="margin-left: 6px;" clearable :class="{ 'vip': assistant && assistant !== '维护人' }">
                <el-option v-for="(item, index) in assistant_id" :key="index" :label="item.name"
                           :value="item.id"></el-option>
              </el-select>
            </div>
            <div style="margin-top: 10px;margin-left: 30px;">
              <span>制作人</span>
              <el-select v-model="make" filterable @change="makeChange" style="margin-left: 6px;" clearable
                         :class="{ 'vip': make && make !== '制作人' }">
                <el-option v-for="(item, index) in make_one" :key="index" :label="item.name" :value="item.staff_id">
                </el-option>
              </el-select>
            </div>
            <div style="margin-top: 10px;margin-left: 15px;">
              <span>项目经理</span>
              <el-select v-model="charge" filterable @change="chargeChange" style="margin-left: 6px;" clearable
                         :class="{ 'vip': charge && charge !== '项目经理' }">
                <el-option v-for="(item, index) in charge_id" :key="index" :label="item.name"
                           :value="item.id"></el-option>
              </el-select>
            </div>
          </div>
          <div>
            <div style="margin-top: 10px;margin-left: 30px;">
              <span>开工时间</span>
              <el-date-picker v-model="value3" style="width: 180px;height: 40px; margin-left: 6px;" type="daterange"
                              @change="getList" @clear="clearValue3" :picker-options="pickerOptions" size="mini"
                              format="yyyy-MM-dd"
                              range-separator="" class="border_box bor_box" start-placeholder="" align="right"
                              value-format="timestamp"
                              :class="{ 'your-css-class': hasValue3}">
              </el-date-picker>
            </div>
            <div style="margin-top: 10px;margin-left: 30px;">
              <span>实际完工</span>
              <el-date-picker v-model="value1" style="width: 180px;height: 40px; margin-left: 6px;" type="daterange"
                              @change="getList" :picker-options="pickerOptions" size="mini" format="yyyy-MM-dd"
                              range-separator=""
                              class="border_box bor_box" clearable start-placeholder="" align="right"
                              value-format="timestamp"
                              :class="{ 'your-css-class': hasValue1 }">
              </el-date-picker>
            </div>
            <div style="margin-top: 10px;margin-left: 30px;">
              <span>上传时间</span>
              <el-date-picker v-model="value2" style="width: 180px;height: 40px; margin-left: 6px;" type="daterange"
                              @change="getList" :picker-options="pickerOptions" size="mini" format="yyyy-MM-dd"
                              range-separator=""
                              class="border_box bor_box" start-placeholder="" align="right" value-format="timestamp"
                              :class="{ 'your-css-class': hasValue2 }">
              </el-date-picker>
            </div>
            <div style="margin-top: 10px;margin-left: 30px;">
              <span>评图时间</span>
              <el-date-picker v-model="score_time_one" style="width: 180px;height: 40px; margin-left: 6px;"
                              type="daterange" @change="getList" :picker-options="pickerOptions" size="mini"
                              format="yyyy-MM-dd"
                              range-separator="" class="border_box bor_box" start-placeholder="" align="right"
                              value-format="timestamp"
                              :class="{ 'your-css-class': hasValue0}">
              </el-date-picker>
            </div>

          </div>
          <div>
            <div style="margin-top: 10px;margin-left: 60px;">
              <span>角度</span>
              <el-select filterable style="margin-left: 6px;" clearable
                         v-model="angleValue"
                         @change="handleAngleChange"
                         :class="{ 'vip': angleValue && angleValue !== '角度' }">
                <el-option v-for="(item, index) in tag_evt[0].children" :key="index" :label="item.name"
                           :value="item.id"></el-option>
              </el-select>
            </div>
            <div style="margin-top: 10px;margin-left: 60px;">
              <span>景别</span>
              <el-select filterable style="margin-left: 6px;" clearable
                         v-model="viewValue"
                         @change="handleViewChange"
                         :class="{ 'vip': viewValue && viewValue !== '景别' }">
                <el-option v-for="(item, index) in tag_evt[1].children" :key="index" :label="item.name"
                           :value="item.id"></el-option>
              </el-select>
            </div>
            <div style="margin-top: 10px;margin-left: 35px;">
              <span>室内类别</span>
              <el-select filterable style="margin-left: 6px;" clearable
                         v-model="indoorTypeValue"
                         @change="handleIndoorTypeChange"
                         :class="{ 'vip': indoorTypeValue && indoorTypeValue !== '室内类别' }">
                <el-option v-for="(item, index) in tag_evt[2].children" :key="index" :label="item.name"
                           :value="item.id"></el-option>
              </el-select>
            </div>
            <div style="margin-top: 10px;margin-left: 35px;">
              <span>建筑类别</span>
              <el-select filterable style="margin-left: 6px;" clearable
                         v-model="buildingTypeValue"
                         @change="handleBuildingTypeChange"
                         :class="{ 'vip': buildingTypeValue && buildingTypeValue !== '建筑类别' }">
                <el-option v-for="(item, index) in tag_evt[3].children" :key="index" :label="item.name"
                           :value="item.id"></el-option>
              </el-select>
            </div>
            <div style="margin-top: 10px;margin-left: 35px;">
              <span>项目区域</span>
              <el-select filterable style="margin-left: 6px;" clearable
                         v-model="projectAreaValue"
                         @change="handleProjectAreaChange"
                         :class="{ 'vip': projectAreaValue && projectAreaValue !== '项目区域' }">
                <el-option v-for="(item, index) in tag_evt[4].children" :key="index" :label="item.name"
                           :value="item.id"></el-option>
              </el-select>
            </div>


          </div>
          <div>
            <div style="margin-top: 10px;margin-left: 35px;">
              <span>评分</span>
              <!-- 评分下拉选择框 -->
              <el-select v-model="score"
                         class="tga_score" multiple placeholder="评分" clearable style="width: 180px; margin-left: 6px;"
                         @change="getList" :class="{ 'vip': score && score.length > 0 }">
                <el-option label="非常好 4.5分以上" value="1"></el-option>
                <el-option label="很好 4.0分以上" value="2"></el-option>
                <el-option label="正常图 3.0-4.0之间" value="3"></el-option>
                <el-option label="差图 3.0分之下" value="4"></el-option>
              </el-select>

            </div>
            <div style="margin-top: 10px;margin-left: 15px;">
              <span>评图状态</span>
              <el-select v-model="design" filterable @change="getList" style="width:180px;height: 40px;" clearable
                         :class="{ 'vip': design && design !== '评图状态' }">
                <el-option v-for="(option, index) in options1" :key="index" :label="option.label" :value="option.value"
                           style=" width:
                  180px;height: 40px;">
                </el-option>
              </el-select>
            </div>
          </div>
          <div></div>
        </div>
      </div>
    </el-dialog>

    <!-- 文件上传开始 -->
    <el-dialog :visible.sync="uploadVisible" width="1090px" :close-on-press-escape="true" :top="dialogTop"
               class="dialogEvt" :destroy-on-close="true">
      <Upload/>
      <span slot="footer" class="dialog-footer"> </span>
    </el-dialog>

    <Work_one v-if="changing == 3" v-show="imgArr_evt.length > 0" @update-data="updateData" :data="imgArr_evt"
              :user="USer" @Min_BOX="Min_BOX" ref="sortTable" :avg="Avg" :staff_e="getstaff"/>


    <Work_two v-if="changing == 4" v-show="imgArr_two.length > 0" :data="imgArr_two" :user="USer_two" @Min_BOX="Min_BOX"
              ref="sortTable" :avg="Avg_two"/>

  </div>
</template>

<script>
import "../../assets/js/flex-images";
import GlobalHeader from '@/components/GlobalHeader.vue'
import Upload from '@/components/Upload.vue'
import {
  ExistsApi,
  indexApi,
  EditApi,
  SearchApi,
  InfoApi,
  DelApi,
  SetApi,
  StatusApi,
  scorelistApi,
  StaffscoreApi,
  DownloadApi,
  GetstaffApi
} from "@/api/work/index.js"


import pinyinMatch from 'pinyin-match';
import Work_one from '@/components/Work_one.vue'
import Work_two from '@/components/Work_two.vue'
import {set} from "core-js/core/dict";

export default {
  components: {
    GlobalHeader,
    Upload,
    Work_one,
    Work_two
  },
  data() {
    return {
      activeIndex: "2",
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "本周",
            onClick(picker) {
              const current = new Date();
              let nowDayOfWeek = current.getDay();
              if (nowDayOfWeek === 0) nowDayOfWeek = 7;
              const dayNum = 1 * 24 * 60 * 60 * 1000;
              const firstDate = new Date(current.valueOf() - (nowDayOfWeek - 1) * dayNum);
              const lastDate = new Date(new Date(firstDate).valueOf() + 6 * dayNum);
              picker.$emit("pick", [firstDate, lastDate]);
            },
          },
          {
            text: "当月",
            onClick(picker) {
              const date = new Date();
              const year = date.getFullYear();
              const month = date.getMonth();
              let thisMonthStartDate = new Date(year, month, 1);
              let thisMonthEndDate = new Date(year, month + 1, 0);
              picker.$emit("pick", [thisMonthStartDate, thisMonthEndDate]);
            },
          },
          {
            text: "当年",
            onClick(picker) {
              var tYear = new Date().getFullYear();
              var startTime = new Date(tYear, 0, 1); //当前年第一天
              var endTime = new Date(tYear, 11, 31); //当前年最后一天
              picker.$emit("pick", [startTime, endTime]);
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit("pick", [start, start]);
            },
          },
          {
            text: "上周",
            onClick(picker) {
              const current = new Date(new Date().getTime() - 60 * 60 * 24 * 7 * 1000);
              let nowDayOfWeek = current.getDay();
              let diffToMonday =
                  current.getDate() - nowDayOfWeek + (nowDayOfWeek === 0 ? -6 : 1);
              const firstDate = new Date(current.setDate(diffToMonday));
              const lastDate = new Date(current.setDate(diffToMonday + 6));
              picker.$emit("pick", [firstDate, lastDate]);
            },
          },
          {
            text: "上月",
            onClick(picker) {
              var now = new Date();
              var fd = new Date(now.getFullYear(), now.getMonth() - 1, 1);
              var ed = new Date(now.getFullYear(), now.getMonth(), 0);
              picker.$emit("pick", [fd, ed]);
            },
          },
          {
            text: "去年",
            onClick(picker) {
              var tYear = new Date().getFullYear() - 1;
              var startTime = new Date(tYear, 0, 1);
              var endTime = new Date(tYear, 11, 31); //当前年最后一天
              picker.$emit("pick", [startTime, endTime]);
            },
          },
        ],
      },
      value1: [], // 初始化为数组
      value2: [], // 初始化为数组
      value3: [], // 初始化为数组
      value4: [], // 初始化为数组
      sortName: "排序方式",
      review: null,
      //收藏次数
      //排序数据
      sort: null,
      changing: 1,
      uploadVisible: false,
      imgArr: [],
      total: null,
      paginationInput: 95,
      currentPage1: 1,
      shiftFirst: false,  //键盘抬起


      //已选中图片数据
      selectArr: [],
      checkValue: false, //chenced的默认值

      form: {},
      formLabelWidth: '80px',
      dialogFormVisible: false,

      ids: null,
      project_id: null,
      staff_id: null,


      project: null,
      project_one: null,

      staff: null,
      staff_one: [],
      labelArr: null,

      name: null,
      customer: null,
      charge: null,
      charge_id: null,
      sign: null,
      set_of: null,
      assistant: null,
      assistant_id: null,
      make: null,
      make_one: null,
      content_remark: null,

      searchLabelDialog: false,
      infoArr: [],
      currentIndex: 0,


      currentImgArrIndex: -1,  // 当前在imgArr中的索引
      currentInfoIndex: 0,
      orField: null,
      orWhere: null,
      copyBrand: [],
      dialogTop: null, // 初始值为1vh
      dialogTop_one: null,
      loading: false,

      ces: false,
      radio: '1',
      options1: [
        {
          value: '1',
          label: '未评图',
        }, {
          value: '2',
          label: '评图中',
        }, {
          value: '3',
          label: '评图结束',
        }, {
          value: '4',
          label: '无需评图',
        }],
      options2: [
        {
          value: 1,
          label: '未评图',
        }, {
          value: 2,
          label: '评图中',
        }, {
          value: 3,
          label: '评图结束',
        }, {
          value: 4,
          label: '无需评图',
        }],


      design: null,
      switch_e: false,
      userRole: null,
      focusDiyIpt: false,
      p: 1,
      type: '',
      score_time: null,


      imgArr_evt: [],
      USer: null,
      Avg: null,

      total_two: null,
      imgArr_two: [],
      Avg_two: null,
      USer_two: null,
      currentPage2: 1,
      score_time_one: null,
      dialogVisible_one: false,
      selectedOptions: {
        project: {
          id: null,
          info: null
        },
        staff: {
          id: null,
          info: null
        },
        reviewType: {
          id: null,
          info: null
        },
        reviewTime: {
          value: null,
          formatted: null
        }
      },
      tag_evt: [
        {children: []},  // 角度的选项
        {children: []},  // 景别的选项
        {children: []},  // 室内类别的选项
        {children: []},  // 建筑类别的选项
        {children: []}   // 项目区域的选项
      ],
      selectedItems: {},
      selectedIds: [],
      customer_box: null,
      TanChuang: null,


      scale: 1, // 图片缩放比例，初始值为1
      maxScale: 2, // 最大缩放比例
      minScale: 1, // 最小缩放比例
      // 新增拖动相关属性
      x: 0,          // 图片X轴偏移
      y: 0,          // 图片Y轴偏移
      isDragging: false,  // 是否正在拖动
      startX: 0,     // 拖动开始时的鼠标X坐标
      startY: 0,     // 拖动开始时的鼠标Y坐标
      initialX: 0,   // 拖动开始时的图片X偏移
      initialY: 0,    // 拖动开始时的图片Y偏移


      customerDisplayText: '',


      angleValue: '',
      viewValue: '',
      indoorTypeValue: '',
      buildingTypeValue: '',
      projectAreaValue: '',
      score: '',
      activeImageId: null,
      imageTags: new Set(), // 用于存储从接口获取的标签ID: {},
      greenTags: new Set(),      // 存储绿色标签ID
      grayTags: new Set(),
      filterConfig: [
        // 第1组：输入框/下拉选择器
        {key: 'name', condition: (vm) => vm.name}, // 项目名称：有值则显示
        {key: 'customer', condition: (vm) => vm.customer && vm.userRole !== 5}, // 客户名称：有值+非角色5
        {key: 'charge', condition: (vm) => vm.charge}, // 项目经理：有值则显示
        {key: 'sign', condition: (vm) => vm.sign && vm.userRole !== 5}, // 签单人：有值+非角色5
        {key: 'assistant', condition: (vm) => vm.assistant && vm.userRole !== 5}, // 维护人：有值+非角色5

        // 第2组：日期选择器
        {key: 'value3', condition: (vm) => vm.value3 && vm.value3.length}, // 开工时间：有值则显示
        {key: 'value4', condition: (vm) => vm.value4 && vm.value4.length}, // 要求时间：有值则显示
        {key: 'value1', condition: (vm) => vm.value1 && vm.value1.length}, // 实际完工：有值则显示
        {key: 'value2', condition: (vm) => vm.value2 && vm.value2.length}, // 上传时间：有值则显示
        {key: 'score_time_one', condition: (vm) => vm.score_time_one && vm.score_time_one.length}, // 评图时间：有值则显示

        // 第3组：剩余选择器
        {key: 'make', condition: (vm) => vm.make}, // 制作人：有值则显示
        {key: 'content_remark', condition: (vm) => vm.content_remark && vm.userRole !== 5}, // 备注：有值+非角色5
        {key: 'design', condition: (vm) => vm.design && vm.userRole === 6}, // 评图状态：有值+角色6
        {key: 'angleValue', condition: (vm) => vm.angleValue}, // 角度：有值则显示
        {key: 'viewValue', condition: (vm) => vm.viewValue}, // 景别：有值则显示
        {key: 'indoorTypeValue', condition: (vm) => vm.indoorTypeValue}, // 室内类别：有值则显示
        {key: 'buildingTypeValue', condition: (vm) => vm.buildingTypeValue}, // 建筑类别：有值则显示
        {key: 'projectAreaValue', condition: (vm) => vm.projectAreaValue}, // 项目区域：有值则显示
        {key: 'score', condition: (vm) => vm.score} // 评分：有值则显示
      ],
      is_score: null,
      getstaff: null,
      imgUrl: require('@/images/33-1.png'),
      preloadRange: 3,
      loadedImages: {},
    };
  },
  created() {
    this.changing = localStorage.getItem('num');


    if (this.changing == null) {
      this.changing = 1;
    }
    this.loading = true
    indexApi().then(res => {
      this.imgArr = res.data
      this.total = res.total,
          this.currentPage1 = res.page - 0;
      this.totalRow = res.totalRow;
      this.loading = false
    })
    SearchApi().then(res => {
      this.project_one = res.project,
          this.staff_one = res.staff,
          this.make_one = res.make,
          this.set_of = res.sign,
          this.assistant_id = res.assistant
      this.charge_id = res.charge
      this.customer_box = res.customer
      //把所有的品牌在赋值copyBrand
      this.copyBrand = this.staff_one
      this.tag_evt = res.tags
    })

    scorelistApi(
        {site: 1}
    ).then(res => {
      this.imgArr_evt = res.data
      this.USer = res.user
      this.Avg = res.average
    });

    StaffscoreApi(
        {site: 1}
    ).then(res => {
      this.imgArr_two = res.data
      this.USer_two = res.user
      this.Avg_two = {
        count: res.count,
        average: res.average,
        score_count: res.score_count
      };
    });

    StatusApi({}).then((res => {
      this.userRole = res.user.role
      // this.userRole = 4
      // role字段 6管理员 3市场 4助理   5
    }))


    GetstaffApi().then((res) => {
      this.getstaff = res.data
    });

    window.addEventListener("keydown", this.handKeyCode, false);
    window.addEventListener("keyup", this.handKeyEvt, true);
  },
  mounted() {
    const storedState = sessionStorage.getItem('switchState');
    this.switch_e = storedState === 'true'; // 关键：字符串转布尔值
    // 在mounted钩子中监听窗口尺寸变化，根据不同尺寸修改dialogTop的值
    this.handleResize()
    window.addEventListener('resize', this.handleResize)
  },
  updated() {
    this.$nextTick(() => {
      new flexImages({
        selector: ".flex-images",
        rowHeight: 280
      });
    });
  },
  beforeDestroy() {
    // 在组件生命周期结束的时候销毁
    window.removeEventListener("keydown", this.handKeyCode, false);
    window.removeEventListener("keyup", this.handKeyEvt, false);
    // 在组件销毁前移除窗口尺寸变化的监听
    window.removeEventListener('resize', this.handleResize)
  },
  computed: {
    // 筛选：所有满足“基础显示条件”的组件（按配置顺序）
    qualifiedComponents() {
      return this.filterConfig.filter(item => {
        // 执行每个组件的业务条件判断（vm指向当前实例）
        return item.condition(this);
      });
    },
    // 最终显示：满足条件的组件中取前6个
    visibleComponents() {
      return this.qualifiedComponents.slice(0, 6);
    },

    buttonStyle() {
      return {
        width: '202px',
        height: '40px',
        marginLeft: '7px',
        backgroundColor: this.buttonColor,
        color: this.buttonTextColor
      };
    },
    buttonText() {
      return this.buttonTextContent;
    },
    buttonColor() {
      return this.p === 2 ? '#409EFF' : this.p === 1 ? '#fff' : '';
    },
    buttonTextColor() {
      return this.p === 1 ? '#606266' : this.p === 2 ? 'white' : '';
    },
    buttonTextContent() {
      return this.p === 1 ? '未参与' : this.p === 2 ? '评图中' : '';
    },
    hasValue1() {
      // 判断 value1 是否有值
      return this.value1 && this.value1.length > 0;
    },
    hasValue2() {
      return this.value2 && this.value2.length > 0;
    },
    hasValue3() {
      return this.value3 && this.value3.length > 0;
    },
    hasValue4() {
      return this.value4 && this.value4.length > 0;
    },
    hasValue0() {
      return this.score_time_one && this.score_time_one.length > 0;
    },
    hasContent() {
      const fields = [
        this.design,
        this.score_time_one,
        this.value2,
        this.content_remark,
        this.make,
        this.value1,
        this.value4,
        this.value3,
        this.assistant,
        this.sign,
        this.charge,
        this.customer,
        this.name,
      ];
      // 检查所有字段的长度是否为0
      return fields.some(field => (field && (Array.isArray(field) ? field.length > 0 : field !== '')));
    }
  },
  methods: {

    gather(e, index) {
      console.log(e, 321);
      if (index == 1) {
        console.log(1);
        this.name = e.project_name

      } else if (index == 2) {
        console.log(2);
        this.customer = e.customer
      } else if (index == 3) {
        console.log(3);
        this.make = e.staff_id
      }
      this.getList()
    },

    switch_evt(value) {
      this.currentIndex = 0
      this.currentImgArrIndex = 0
      localStorage.setItem('switchState', value.toString());
    },

    tanchuangEvt() {
      requestAnimationFrame(() => {
        this.searchLabelDialog = false;
        this.currentIndex = 0; // 重置当前索引
        this.currentImgArrIndex = 0
      });
    },
    changeImg(type) {
      if (type === 'enter') {
        this.imgUrl = require('@/images/33.png'); // 移入：33.png
      } else {
        this.imgUrl = require('@/images/33-1.png'); // 移出：33-3.png
      }
    },
    shouldShowItem(componentKey) {
      // 检查组件是否在“前6个满足条件的组件”中
      return this.visibleComponents.some(item => item.key === componentKey);
    },
    download() {
      // 根据 switch_e 的值选择不同的 id
      const id = this.switch_e ? this.selectArr[this.currentIndex].id : this.TanChuang;

      DownloadApi({id})
          .then(res => {
            // 检查是否获取到了有效的下载URL
            if (res.code === 1000) {
              const link = document.createElement('a');
              // 设置下载链接
              link.href = res.data.url;
              // 将a标签添加到页面并模拟点击
              document.body.appendChild(link);
              link.click();
              // 下载完成后移除a标签
              document.body.removeChild(link);
            }
          });
    },

    // 角度选择变化处理
    handleAngleChange(value) {
      this.angleValue = value;
      this.getList()
    },
    // 景别选择变化处理
    handleViewChange(value) {
      this.viewValue = value;
      this.getList()
    },
    // 室内类别选择变化处理
    handleIndoorTypeChange(value) {
      this.indoorTypeValue = value
      this.getList()
    },
    // 建筑类别选择变化处理
    handleBuildingTypeChange(value) {
      this.buildingTypeValue = value
      this.getList()
    },
    // 项目区域选择变化处理
    handleProjectAreaChange(value) {
      this.projectAreaValue = value
      this.getList()
    },


    handleMouseWheel(event) {
      // 反转方向：deltaY > 0 时是缩小（减去缩放值），deltaY < 0 时是放大（增加缩放值）
      const delta = event.deltaY > 0 ? -0.1 : 0.1;
      // 确保缩放不会小于1
      this.scale = Math.min(this.maxScale, Math.max(this.minScale, this.scale + delta));
    },
    // 新增拖动方法
    startDrag(event) {
      event.preventDefault(); // 阻止默认行为，防止拖动时页面滚动
      // 只有当图片放大到超过原始尺寸时才允许拖动
      if (this.scale > 1) {
        this.isDragging = true;
        this.startX = event.clientX;
        this.startY = event.clientY;
        this.initialX = this.x;
        this.initialY = this.y;
      }
    },

    handleDrag(event) {
      event.preventDefault();
      if (!this.isDragging) return;

      const deltaX = event.clientX - this.startX;
      const deltaY = event.clientY - this.startY;

      // 计算新的位置（考虑缩放影响）
      const newX = this.initialX + deltaX / this.scale;
      const newY = this.initialY + deltaY / this.scale;

      // 使用requestAnimationFrame优化动画性能
      if (!this.animationFrameId) {
        this.animationFrameId = requestAnimationFrame(() => {
          this.x = newX;
          this.y = newY;
          this.animationFrameId = null;
        });
      }
    },

    endDrag() {
      this.isDragging = false;
      if (this.animationFrameId) {
        cancelAnimationFrame(this.animationFrameId);
        this.animationFrameId = null;
      }
    },
    resetImage() {
      this.scale = 1; // 重置缩放比例为1（原始大小）
      this.x = 0;     // 重置X轴位置
      this.y = 0;     // 重置Y轴位置
    },


    TogSelection(category, item, id) {
      // 初始化存储原始状态的对象
      this.originalTagType = this.originalTagType || {};

      // 当前状态判断
      const isGreen = this.greenTags.has(id);
      const isGray = this.grayTags.has(id);
      const isImageTag = isGreen || isGray;
      const isManuallySelected = this.selectedIds.includes(id);
      const isSelected = this.TogisSelected(category, item, id);


      // 确保分类数组存在
      if (!this.selectedItems[category]) {
        this.$set(this.selectedItems, category, []);
      }

      // 处理灰色标签的三态循环：灰色 → 绿色 → 白色 → 灰色
      if (isGray) {
        // 1. 灰色 → 绿色：记录原始状态为灰色
        this.originalTagType[id] = 'gray';
        this.grayTags.delete(id);
        this.greenTags.add(id);
        this.imageTags.add(id);
        this.selectedItems[category].push(item);
        this.selectedIds.push(id);
        return;
      }

      // 处理绿色状态
      if (isGreen || isManuallySelected) {
        // 2. 绿色 → 白色：清除绿色状态
        this.greenTags.delete(id);
        this.imageTags.delete(id);
        this.selectedItems[category] = this.selectedItems[category].filter(i => i !== item);
        this.selectedIds = this.selectedIds.filter(tagId => tagId !== id);
        return;
      }

      // 处理白色状态
      if (!isSelected) {
        // 3. 白色 → 恢复原始状态（灰色或绿色）
        if (this.originalTagType[id] === 'gray') {
          // 恢复到灰色
          this.grayTags.add(id);
          this.imageTags.add(id);
          delete this.originalTagType[id];
          // 强制触发响应式更新
          this.$set(this, 'grayTags', new Set(this.grayTags));
        } else if (isImageTag) {
          // 切换到绿色
          this.greenTags.add(id);
          this.imageTags.add(id);
        } else {
          // 普通标签切换到绿色
          this.selectedItems[category].push(item);
          this.selectedIds.push(id);
        }
        return;
      }
    },


    TogisSelected(category, item, id) {
      const isManuallySelected = this.selectedItems[category] &&
          Array.isArray(this.selectedItems[category]) &&
          this.selectedItems[category].includes(item) &&
          this.selectedIds.includes(id);

      const isImageTag = this.imageTags.has(id);

      return isManuallySelected || isImageTag;
    },
    isGreenTag(id) {
      return this.greenTags.has(id);
    },

    // 判断是否为灰色标签
    isGrayTag(id) {
      return this.grayTags.has(id);
    },

    // 修改 isSelected 方法，只依赖当前项目的 tags
    isSelected(e, subItemId) {
      // 只检查当前项目的 tags 中是否包含该 ID
      // 移除对 selectedIds 的依赖，因为它只是 e.tags 的副本
      return Array.isArray(e.tags) && e.tags.includes(subItemId);
    },

    // 优化 toggleSelection 方法
    toggleSelection(e, category, item, id) {
      // 确保当前项目有 tags 数组
      if (!Array.isArray(e.tags)) {
        this.$set(e, 'tags', []);
      }

      // 确保当前分类有选中项存储
      if (!this.selectedItems[category]) {
        this.$set(this.selectedItems, category, []);
      }
      // 检查当前标签是否已选中
      const isSelected = e.tags.includes(id);
      const itemIndexInCategory = this.selectedItems[category].indexOf(item);
      if (isSelected) {
        // 取消选中
        // 从 tags 中移除 ID
        e.tags = e.tags.filter(tagId => tagId !== id);
        // 从分类选中项中移除文本
        if (itemIndexInCategory > -1) {
          this.selectedItems[category].splice(itemIndexInCategory, 1);
        }
      } else {
        // 选中
        // 添加 ID 到 tags
        e.tags.push(id);
        // 添加文本到分类选中项（如果不存在）
        if (itemIndexInCategory === -1) {
          this.selectedItems[category].push(item);
        }
      }

      // 同步到 selectedIds
      this.selectedIds = [...e.tags];
      this.submitForm();
    },
    // 项目选择变化处理
    handleProjectChange(selectedId) {
      // 存储选中的ID
      this.selectedOptions.project.id = selectedId;
      // 查找对应的项目信息
      this.selectedOptions.project.info = this.project_one.find(project => project.id === selectedId) || null;
      this.submitForm()
    },

    // 制作人选择变化处理
    handleStaffChange(selectedId) {
      this.selectedOptions.staff.id = selectedId;
      this.selectedOptions.staff.info = this.staff_one.find(staff => staff.id === selectedId) || null;
      this.submitForm()
    },

    // 评图类型选择变化处理
    handleReviewTypeChange(selectedValue) {
      this.selectedOptions.reviewType.id = selectedValue;
      this.selectedOptions.reviewType.info = this.options2.find(option => option.value === selectedValue) || null;
      this.submitForm()
    },
    // 评图时间选择变化处理
    handleReviewTimeChange(selectedDate) {
      this.selectedOptions.reviewTime.value = selectedDate;
      this.selectedOptions.reviewTime.formatted = selectedDate ? selectedDate.toLocaleDateString() : null;
      this.submitForm();
    },


    submitForm() {
      // 获取当前正在编辑的项目
      const currentItem = this.infoArr[this.currentIndex];

      // 转换reviewTime为秒级时间戳
      const reviewTimestamp = this.selectedOptions.reviewTime.value
          ? Math.floor(new Date(this.selectedOptions.reviewTime.value).getTime() / 1000)
          : null;

      EditApi({
        ids: [this.switch_e ? this.selectArr[this.currentIndex].id : this.imgArr[this.currentImgArrIndex].id],
        project_id: this.selectedOptions.project.id, // 使用从项目选择器获取的ID
        staff_id: this.selectedOptions.staff.id,     // 使用从制作人选择器获取的ID
        is_score: this.selectedOptions.reviewType.id,    // 使用从评图类型选择器获取的ID
        green: currentItem.tags || this.selectedIds,    // 优先使用当前项的tags，其次使用全局selectedIds
        score_time: reviewTimestamp
      }).then(res => {
        if (res.code == 1000) {
          this.dialogFormVisible = false;

          // 重置表单状态
          this.selectedIds = [];
          this.selectedItems = {};
          this.score_time = '';
          this.p = 1;

          let ids = [];
          if (this.switch_e == false) {
            // 当switch_e为false时，使用this.TanChuang
            if (this.TanChuang) {
              console.log(this.TanChuang, 312312);

              ids.push(this.TanChuang);
            }
          } else {
            // 当switch_e为true时，使用this.selectArr中的所有id
            if (this.selectArr && this.selectArr.length) {
              // 假设数组元素是对象，且id属性存储在item.id中
              const selectIds = this.selectArr.map(item => item.id);
              // 过滤掉可能存在的空id（可选）
              ids.push(...selectIds.filter(id => id));
            }
          }

          InfoApi({id: ids}).then(res => {
            this.searchLabelDialog = true;
            this.infoArr = res.data.images.reverse();
            this.currentIndex = 0;  // 重置到第一个项目
          });
        } else {
          alert(res.msg);
        }
      }).catch(error => {
      });
    },


    updateData(updatedData) {
      this.imgArr_evt = updatedData; // 更新父组件中的data属性
    },
    typeChange(value) {
      this.type = value
    },
    //将排序参数传递给子组件
    Min_BOX(props) {
      this.orField = props.orWhere;
      (this.orWhere = props.order), this.getList();
    },
    clearValue3() {
      console.log(123);
    },
    changeStatus() {
      if (this.p === 1) {
        this.p = 2; // 如果当前状态是1，点击后切换为2
      } else if (this.p === 2) {
        this.p = 1; // 如果当前状态是2，点击后切换为3
      }
    },
    //这个是为了避免输入框输入内容的时候 触发键盘事件
    focusDiyIptEvt() {
      this.focusDiyIpt = true;
    },
    handleResize() {
      // 根据不同的屏幕尺寸设置不同的top值
      if (window.innerWidth <= 1920) {
        this.dialogTop = '6vh'
        this.dialogTop_one = '3vh'
      } else if (window.innerWidth <= 2560) {
        this.dialogTop = '10vh'
        this.dialogTop_one = '9vh'
      } else if (window.innerWidth <= 3440) {
        this.dialogTop = '15vh'
        this.dialogTop_one = '9vh'
      } else if (window.innerWidth <= 3840) {
        this.dialogTop = '20vh'
        this.dialogTop_one = '15vh'

      }
    },
    //关闭弹窗前的
    clone_eEvt() {
      this.project = '';
      this.staff = '';
      this.design = '';
      this.type = '';
      this.score_time = '';
      this.dialogFormVisible = false
    },
    //刪除图片
    ClonaEvt(e) {
      e = e || window.event;
      e.preventDefault()
      this.ces = true;
      const ids = this.getSourceId(); // 获取res数组
      if (this.imgArr.filter((res) => res.select == true).length !== 0) {
        this.$confirm('此操作将永久删除该图片, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$message({type: 'success', message: '删除成功!'});
          DelApi({
            ids: ids
          }).then(res => {
            // 从imgArr中移除被删除的图片
            if (res.code == 1000) {
              this.imgArr = this.imgArr.filter(res => res.select !== true);
              this.ces = false
              StatusApi({}).then((res => {
                this.img_num = res.img_num
                localStorage.setItem('img_num', this.img_num);
              }))
            } else {
              this.$message({type: 'error', message: '删除失败!'});
            }
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
          this.ces = false;
        });


      }
    },
    //下拉查找中文字母查詢
    pinyingMatch(val) {
      var inputValue = val; // 保存输入的值
      if (val) {
        var result = [];
        this.copyBrand.forEach(e => {
          var matched = true;
          for (var i = 0; i < val.length; i++) {
            var m = pinyinMatch.match(e.name, val.slice(i, i + 1));
            if (!m) {
              matched = false;
              break;
            }
          }
          if (matched) {
            result.push(e);
          }
        });
        this.staff_one = result;
      } else {
        this.staff_one = this.copyBrand;
      }
      this.staff = inputValue; // 将输入的值赋值回输入框
    },
    //空格打开弹窗关闭事件
    clearValues() {
      // 清空相关值
      this.infoArr = [];
      this.currentIndex = 0;
    },
    //切换上一页
    prevImage() {

      if (!this.switch_e) {
        if (this.currentImgArrIndex > 0) {
          this.currentImgArrIndex--;
          const prevItem = this.imgArr[this.currentImgArrIndex];

          // 根据switch_e决定是否发起新请求
          if (!this.switch_e) {
            // 发起新请求加载该图片的信息
            InfoApi({id: prevItem.id}).then(res => {
              this.infoArr = res.data.images.reverse();
              this.currentInfoIndex = 0;
              this.TanChuang = prevItem.id
            });
          }
        }
      } else if (this.currentIndex > 0) {
        this.currentIndex--;
        this.loadCurrentAndPreload(this.currentIndex);
      }
      this.resetImage()
    },
    //切换下一页
    nextImage() {
      if (!this.switch_e) {
        if (this.currentImgArrIndex < this.imgArr.length - 1) {
          this.currentImgArrIndex++;
          const nextItem = this.imgArr[this.currentImgArrIndex];
          // 根据switch_e决定是否发起新请求
          if (!this.switch_e) {
            // 发起新请求加载该图片的信息
            InfoApi({id: nextItem.id}).then(res => {
              this.infoArr = res.data.images.reverse();
              this.currentInfoIndex = 0;
              this.TanChuang = nextItem.id;
            });
          }
        }
      } else if (this.currentIndex < this.infoArr.length - 1) {
        this.currentIndex++;
        this.loadCurrentAndPreload(this.currentIndex);
      }
      this.resetImage()


    },

    //键盘抬起事件
    handKeyEvt(e) {
      e = e || window.event;
      if (e.keyCode == 16) {
        this.shift = false;
        this.shiftFirst = false;
      }
    },
    //空格事件
    handKeyCode(e) {
      e = e || window.event;
      if (this.focusDiyIpt == true || this.dialogFormVisible == true) {
        return;
      }
      if (this.switch_e == false) {
        // 键盘左键事件
        if (e.keyCode == 37) {
          e.preventDefault();
          this.prevImage();
        }
        //键盘右键事件
        if (e.keyCode == 39) {
          e.preventDefault();
          this.nextImage();
        }
        //Page Up 翻页
        if (e.keyCode == 34) {
          if (this.dialogVisible || this.searchLabelDialog || this.rightLabelDialog || this.deleteVisible || this.uploadVisible || this.dialogFormVisible) {
            e.preventDefault();
            return; // 有弹窗打开，不执行翻页
          }
          e.preventDefault();
          this.currentPage1++;
          this.getList()
        }
        // Page Down向后分页
        if (e.keyCode == 33) {
          if (this.dialogVisible || this.searchLabelDialog || this.rightLabelDialog || this.deleteVisible || this.uploadVisible || this.dialogFormVisible) {
            e.preventDefault();
            return; // 有弹窗打开，不执行翻页
          }
          if (this.currentPage1 <= 1) {
            this.currentPage1 = 1;
          } else {
            this.currentPage1--;
          }
          this.getList()
        }

        return
      } else if (this.imgArr.filter((res) => res.select == true).length !== 0) {
        //空格空格事件
        if (e.keyCode == 32) {
          if (this.ces == true) {
            this.searchLabelDialog = false;
            return;
          }
          this.searchLabelDialog = true;

          // 优先使用选中的图片ID，如果有多个选中则使用第一个
          let targetIds;
          if (this.selectArr.length > 0) {
            // 如果有选中的图片，使用选中的图片ID
            targetIds = this.selectArr.map(item => item.id);
            // 记录当前打开的是哪个ID（这里取第一个选中的）
            this.activeImageId = targetIds[0];

          } else {
            // 如果没有选中的，使用原来的方式获取ID
            targetIds = this.getSourceId();
          }

          InfoApi({
            id: targetIds
          }).then(res => {
            this.infoArr = res.data.images.reverse();
            this.loadCurrentAndPreload(this.currentIndex);
          })

          e.preventDefault();
        }
        // 键盘左键事件
        if (e.keyCode == 37) {
          e.preventDefault();
          this.prevImage();
        }
        //键盘右键事件
        if (e.keyCode == 39) {
          e.preventDefault();
          this.nextImage();
        }
      }
      //shift 事件
      if (e.keyCode == 16) {
        this.shift = true;
        this.shiftFirst = true;
      }
      //键盘0清除选择
      if (e.keyCode == 48 || e.keyCode == 96 || e.keyCode == 67) {
        if (
            this.dialogVisible == true ||
            this.searchLabelDialog == true ||
            this.rightLabelDialog == true ||
            this.deleteVisible == true ||
            this.uploadVisible == true
        ) {
          return;
        }
        this.imgArr = this.imgArr.map(res => {
          res.select = false;
          return res;
        });
        this.selectArr = this.imgArr.filter(res => res.select == true);
      }
      //键盘A事件（全选）
      if (e.keyCode == 65) {
        this.imgArr = this.imgArr.map(res => {
          res.select = true;
          return res;
        });
        this.selectArr = this.imgArr.filter(res => res.select == true);
      }
      if (e.keyCode == 110 || e.keyCode == 46) {
        this.ClonaEvt()
      }

      //加入评图
      if (e.keyCode == 80) {
        if (this.userRole == 6) {
          const ids = this.getSourceId(); // 获取res数组
          EditApi({
            ids: ids, // 将res数组作为ids参数传递
            type: 2,
          }).then(res => {
            if (res.code == 1000) {
              this.imgArr = this.imgArr.filter(img => !ids.includes(img.id));
              this.dialogFormVisible = false;
              this.project = '';
              this.staff = '';
              this.ids = '';
              this.type = '';
              this.score_time = '';

              this.$message({
                message: '已加入评图',
                type: 'success'
              });
            } else {
              alert(res.msg)
            }
          });
        }
      }
      //退出评图
      if (e.keyCode == 79) {
        if (this.userRole == 6) {
          const ids = this.getSourceId(); // 获取res数组
          EditApi({
            ids: ids, // 将res数组作为ids参数传递
            type: 1,
          }).then(res => {
            if (res.code == 1000) {
              this.dialogFormVisible = false;
              this.project = '';
              this.staff = '';
              this.ids = '';
              this.type = '';
              this.score_time = '';
              this.$message('已退出评图');
            } else {
              alert(res.msg)
            }
          });
        }
      }

      //Page Up 翻页
      if (e.keyCode == 34) {
        if (this.dialogVisible || this.searchLabelDialog || this.rightLabelDialog || this.deleteVisible || this.uploadVisible || this.dialogFormVisible) {
          e.preventDefault();
          return; // 有弹窗打开，不执行翻页
        }
        e.preventDefault();
        this.currentPage1++;
        this.getList()
      }
      // Page Down向后分页
      if (e.keyCode == 33) {
        if (this.dialogVisible || this.searchLabelDialog || this.rightLabelDialog || this.deleteVisible || this.uploadVisible || this.dialogFormVisible) {
          e.preventDefault();
          return; // 有弹窗打开，不执行翻页
        }
        if (this.currentPage1 <= 1) {
          this.currentPage1 = 1;
        } else {
          this.currentPage1--;
        }
        this.getList()
      }

    },

    loadCurrentAndPreload(currentIdx) {
      const total = this.infoArr.length;
      if (total === 0) return;

      // 1. 先加载当前图（确保用户能尽快看到）
      const currentImg = this.infoArr[currentIdx];
      this.loadSingleImage(currentImg.id).then(() => {
        this.loading = false; // 关闭初始化提示，显示当前图
      });

      // 2. 预加载当前图前后preloadRange张（后台偷偷加载，不阻塞UI）
      const preloadStart = Math.max(0, currentIdx - this.preloadRange);
      const preloadEnd = Math.min(total - 1, currentIdx + this.preloadRange);
      for (let i = preloadStart; i <= preloadEnd; i++) {
        if (i !== currentIdx) { // 跳过已加载的当前图
          this.loadSingleImage(this.infoArr[i].id);
        }
      }
    },

    // 加载单张图片（缓存已加载的图，避免重复请求）
    loadSingleImage(imgId) {
      return new Promise((resolve) => {
        // 若已加载过，直接返回
        if (this.loadedImages[imgId]) {
          resolve();
          return;
        }

        // 找到该图片的原图URL
        const imgInfo = this.infoArr.find(item => item.id === imgId);
        if (!imgInfo) {
          resolve();
          return;
        }

        // 创建Image对象加载原图（后台加载，不阻塞DOM）
        const img = new Image();
        img.src = imgInfo.originUrl;
        img.onload = () => {
          this.loadedImages[imgId] = img; // 缓存已加载的图
          resolve();
        };
        img.onerror = () => {
          this.loadedImages[imgId] = "error"; // 标记错误，避免重复加载
          resolve();
        };
      });
    },


    //排序
    sortEvt(res) {
      this.sort = res
      switch (res) {
        case "1":
          this.sortName = "上传时间-升序";
          this.orField = 1;
          this.orWhere = 'asc'
          break;
        case "1-1":
          this.sortName = "上传时间-升序";
          this.orField = 1;
          this.orWhere = 'desc'
          break;
        case "2":
          this.sortName = "项目开工时间-升序";
          this.orField = 2;
          this.orWhere = 'asc'
          break;
        case "2-1":
          this.sortName = "项目开工时间-降序";
          this.orField = 2;
          this.orWhere = 'desc'
          break;
        case "3":
          this.sortName = "项目完工时间-升序";
          this.orField = 3;
          this.orWhere = 'asc'
          break;
        case "3-1":
          this.sortName = "项目完工时间-降序";
          this.orField = 3;
          this.orWhere = 'desc'
          break;
        case "4":
          this.sortName = "文件尺寸-升序";
          this.orField = 4;
          this.orWhere = 'asc'
          break;
        case "4-1":
          this.sortName = "文件尺寸-降序";
          this.orField = 4;
          this.orWhere = 'desc'
          break;
        case "5":
          this.sortName = "评分-升序";
          this.orField = 5;
          this.orWhere = 'asc'
          break;
        case "5-1":
          this.sortName = "评分-降序";
          this.orField = 5;
          this.orWhere = 'desc'
          break;
      }

      this.getList()
    },
    //切换排序方式
    changingEvt(e) {
      this.changing = e
      localStorage.setItem('num', e);
    },
    mousemoveEvt() {
    },
    mouseoutEvt() {
    },
    //上传
    uploadEvt() {
      this.uploadVisible = true;
    },
    handleCurrentChange(res) {
      this.loading = true
      setTimeout(() => {
        this.getList();
        this.loading = false
      }, 100)
    },
    // 获取已选中图片的source_id
    getSourceId() {
      var source_ids = this.selectArr.map(res => res.id);
      return source_ids;
    },
    //图片点击事件
    imgEvt(e, index) {
      if (this.switch_e == false) {
        // 记录当前在imgArr中的索引
        this.currentImgArrIndex = index;
        const ids = e.id;
        this.TanChuang = ids
        InfoApi({id: ids}).then(res => {
          this.searchLabelDialog = true;
          this.infoArr = res.data.images.reverse();
          this.currentInfoIndex = 0; // 重置infoArr中的索引
        });
        return;
      }

      if (this.selectArr.length >= 1 && this.shift === true) {
        let start,
            end = "";
        for (var i = 0; this.imgArr.length > i; i++) {
          if (this.imgArr[i].id === e.id) {
            start = i;
          }
          if (
              this.imgArr[i].id !== e.id &&
              this.imgArr[i].select === true
          ) {
            end = i;
          }
        }
        if (start || (start == 0 && end)) {
          if (start > end) {
            let temp = "";
            temp = end;
            end = start;
            start = temp;
          } else {
            start++;
          }
          for (var i = 0; this.imgArr.length > i; i++) {
            if (i >= start && i < end) {
              this.imgArr[i].select = true;
            }
          }
        }
      }

      this.imgArr = this.imgArr.map(res => {
        if (res.id == e.id) {
          // 点击时更新当前激活的图片ID
          this.activeImageId = e.id;

          if (res.select) {
            res.select = "";
          } else {
            res.select = true;
          }
        }
        return res;
      });

      this.selectArr = this.imgArr.filter(res => res.select == true);
      this.resetImage();
      this.resetImage()
    },
    //图片鼠标右键事件
    rightClickEvt() {
      if (this.selectArr.length !== 0) {
        // 提取并处理项目、员工、类型和评分时间（保持原有逻辑）
        const projectIds = this.selectArr.map(item => item.project_id);
        const uniqueProjectIds = [...new Set(projectIds)];

        const staffs = this.selectArr.map(item => item.staff_id);
        const uniqueStaffs = [...new Set(staffs)];

        const types = this.selectArr.map(item => item.type);
        const uniqueTypes = [...new Set(types)];

        const scoreTimes = this.selectArr.map(item => item.score_time);
        const uniqueScoreTimes = [...new Set(scoreTimes)];

        // 新增：处理客户信息
        const customerIds = this.selectArr.map(item => item.customer_id);
        const uniqueCustomerIds = [...new Set(customerIds)];

        // 判断是否所有客户ID都相同
        const allSameCustomer = uniqueCustomerIds.length === 1;

        // 设置客户显示文本
        if (allSameCustomer) {
          // 如果客户ID相同，显示对应的客户名称
          // 假设第一个选中项的customer_name就是该客户的名称

          this.customerDisplayText = this.selectArr[0].customer;
        } else {
          // 如果客户ID不同，显示"多个客户"
          this.customerDisplayText = "多个客户";
        }

        // 保持原有的其他逻辑
        if (uniqueProjectIds.length === 1 && uniqueStaffs.length === 1) {
          this.project = uniqueProjectIds[0];
          this.staff = uniqueStaffs[0];
          this.type = uniqueTypes[0];
          this.score_time = uniqueScoreTimes[0];
        }

        let allEqual = uniqueProjectIds.every((val, i, arr) => val === arr[0]);
        this.project = allEqual ? uniqueProjectIds[0] : '';

        // 优先使用选中的图片ID，如果有多个选中则使用第一个
        let targetIds;
        if (this.selectArr.length > 0) {
          // 如果有选中的图片，使用选中的图片ID
          targetIds = this.selectArr.map(item => item.id);
          // 记录当前打开的是哪个ID（这里取第一个选中的）
          this.activeImageId = targetIds[0];
        } else {
          // 如果没有选中的，使用原来的方式获取ID
          targetIds = this.getSourceId();
        }

        InfoApi({
          id: targetIds
        }).then(res => {
          this.dialogFormVisible = true;
          this.infoArr = res.data.images.reverse();

          // 重置选中状态 - 关键修改
          this.selectedItems = {};  // 清空所有手动选择的项目
          this.selectedIds = [];    // 清空所有手动选择的ID
          // 清空所有标签集合
          this.imageTags.clear();
          this.greenTags.clear();
          this.grayTags.clear();

          // 处理绿色标签
          if (res.data.tags.green && Array.isArray(res.data.tags.green)) {
            res.data.tags.green.forEach(id => {
              this.greenTags.add(id);
              this.imageTags.add(id); // 加入总标签集合用于判断选中状态
            });
          }

          // 处理灰色标签
          if (res.data.tags.gray && Array.isArray(res.data.tags.gray)) {
            res.data.tags.gray.forEach(id => {
              this.grayTags.add(id);
              this.imageTags.add(id); // 加入总标签集合用于判断选中状态
            });
          }
        });
      }
    },

    projectChange(selectedId) {
      // 重置显示文本
      this.customerDisplayText = '';
      if (selectedId) {
        // 找到选中的项目
        const selectedProject = this.project_one.find(item => item.id === selectedId);

        if (selectedProject && selectedProject.customer_name) {
          // 将客户名称赋值给显示文本
          this.customerDisplayText = selectedProject.customer_name;
        } else {
          this.customerDisplayText = '未找到客户信息';
        }
      }
    },
    staffChange(value) {
      this.staff = value;
    },

    okEvt() {
      const ids = this.getSourceId(); // 获取res数组

      // 1. 先将绿色标签转换为数组
      const greenTagIds = this.greenTags.size > 0 ? [...this.greenTags] : [];

      // 2. 合并手动选择的标签ID（去重处理）
      const mergedGreenTags = [...new Set([...greenTagIds, ...this.selectedIds])];

      // 3. 灰色标签转换为数组
      const grayTagIds = this.grayTags.size > 0 ? [...this.grayTags] : [];

      EditApi({
        ids: ids,
        project_id: this.project,
        staff_id: this.staff,
        is_score: this.type,
        score_time: new Date(this.score_time).getTime() / 1000,
        green: mergedGreenTags,  // 合并了手动选择的绿色标签数组
        gray: grayTagIds,         // 灰色标签数组
      }).then(res => {
        if (res.code == 1000) {
          if (this.type == 2) {
            this.imgArr = this.imgArr.filter(img => !ids.includes(img.id));
          }
          this.dialogFormVisible = false;
          this.project = '';
          this.staff = '';
          this.ids = '';
          this.p = 1;
        } else {
          alert(res.msg)
        }
      });
    },

    imgScrollEvt(e) {
    },
    //签单人选择下拉内容
    makeChange(value) {
      this.make = value;
      this.getList()
    },
    //维护人选择下拉内容
    assistantChange(value) {
      this.assistant = value;
      this.getList()
    },
    //签单人选择下拉内容
    signChange(value) {
      this.sign = value;
      this.getList()
    },
    //项目经理
    chargeChange(value) {
      this.charge = value;
      this.getList()
    },
    //评图
    getList() {
      this.loading = true;
      let formatDate = (value) => {
        if (value) {
          let timestamp = Math.floor(value / 1000);
          let date = new Date(timestamp * 1000);
          date.setHours(23, 59, 59);
          return Math.floor(date.getTime() / 1000);
        }
        return '';
      };


      if (this.changing == 1 || this.changing == 2) {
        let data = {
          orField: this.orField,
          orWhere: this.orWhere,
          limit: this.paginationInput,
          page: this.currentPage1,
          name: this.name,
          customer: this.customer,
          charge: this.charge,
          sign: this.sign,
          assistant: this.assistant,
          make: this.make,
          content_remark: this.content_remark,
          upload_start: this.value2 && this.value2[0] ? formatDate(this.value2[0]) : '',
          upload_end: this.value2 && this.value2[1] ? formatDate(this.value2[1]) : '',
          end_time_start: this.value1 && this.value1[0] ? formatDate(this.value1[0]) : '',
          end_time_end: this.value1 && this.value1[1] ? formatDate(this.value1[1]) : '',
          start_time_start: this.value3 && this.value3[0] ? formatDate(this.value3[0]) : '',
          start_time_end: this.value3 && this.value3[1] ? formatDate(this.value3[1]) : '',
          demand_time_start: this.value4 && this.value4[0] ? formatDate(this.value4[0]) : '',
          demand_time_end: this.value4 && this.value4[1] ? formatDate(this.value4[1]) : '',
          p: this.design,
          score_time_start: this.score_time_one && this.score_time_one[0] ? formatDate(this.score_time_one[0]) : '',
          score_time_end: this.score_time_one && this.score_time_one[1] ? formatDate(this.score_time_one[1]) : '',
          tags0: this.angleValue,
          tags1: this.viewValue,
          tags2: this.indoorTypeValue,
          tags3: this.buildingTypeValue,
          tags4: this.projectAreaValue,
          score_type: this.score

        };
        indexApi(data).then(res => {
          this.loading = false;
          this.imgArr = res.data;
          this.total = res.total;
          this.paginationInput = res.limit;
          this.focusDiyIpt = false;
        })
      } else if (this.changing == 3) {
        scorelistApi(
            {
              site: 1,
              limit: this.paginationInput,
              page: this.currentPage1,
              name: this.name,
              customer: this.customer,
              charge: this.charge,
              sign: this.sign,
              assistant: this.assistant,
              make: this.make,
              content_remark: this.content_remark,
              upload_start: this.value2 && this.value2[0] ? formatDate(this.value2[0]) : '',
              upload_end: this.value2 && this.value2[1] ? formatDate(this.value2[1]) : '',
              end_time_start: this.value1 && this.value1[0] ? formatDate(this.value1[0]) : '',
              end_time_end: this.value1 && this.value1[1] ? formatDate(this.value1[1]) : '',
              start_time_start: this.value3 && this.value3[0] ? formatDate(this.value3[0]) : '',
              start_time_end: this.value3 && this.value3[1] ? formatDate(this.value3[1]) : '',
              demand_time_start: this.value4 && this.value4[0] ? formatDate(this.value4[0]) : '',
              demand_time_end: this.value4 && this.value4[1] ? formatDate(this.value4[1]) : '',
              p: this.design,
              orField: this.orField,
              orWhere: this.orWhere,
              score_time_start: this.score_time_one && this.score_time_one[0] ? formatDate(this.score_time_one[0]) : '',
              score_time_end: this.score_time_one && this.score_time_one[1] ? formatDate(this.score_time_one[1]) : ''
            }
        ).then(res => {
          this.imgArr_evt = res.data
          this.USer = res.user
          this.Avg = res.average;
          this.focusDiyIpt = false;
          this.loading = false;

        });
      } else if (this.changing == 4) {
        StaffscoreApi(
            {
              site: 1,
              limit: this.paginationInput,
              page: this.currentPage1,
              name: this.name,
              customer: this.customer,
              charge: this.charge,
              sign: this.sign,
              assistant: this.assistant,
              make: this.make,
              content_remark: this.content_remark,
              upload_start: this.value2 && this.value2[0] ? formatDate(this.value2[0]) : '',
              upload_end: this.value2 && this.value2[1] ? formatDate(this.value2[1]) : '',
              end_time_start: this.value1 && this.value1[0] ? formatDate(this.value1[0]) : '',
              end_time_end: this.value1 && this.value1[1] ? formatDate(this.value1[1]) : '',
              start_time_start: this.value3 && this.value3[0] ? formatDate(this.value3[0]) : '',
              start_time_end: this.value3 && this.value3[1] ? formatDate(this.value3[1]) : '',
              demand_time_start: this.value4 && this.value4[0] ? formatDate(this.value4[0]) : '',
              demand_time_end: this.value4 && this.value4[1] ? formatDate(this.value4[1]) : '',
              p: this.design,
              orField: this.orField,
              orWhere: this.orWhere,
              score_time_start: this.score_time_one && this.score_time_one[0] ? formatDate(this.score_time_one[0]) : '',
              score_time_end: this.score_time_one && this.score_time_one[1] ? formatDate(this.score_time_one[1]) : ''
            }
        ).then(res => {
          this.imgArr_two = res.data
          this.USer_two = res.user,
              this.focusDiyIpt = false;
          this.loading = false;
          this.Avg_two = {
            count: res.count,
            average: res.average,
            score_count: res.score_count
          };
        });
      }

    },
    cloneEvt() {
      this.loading = true
      this.name = '';
      this.customer = '';
      this.charge = '';
      this.sign = '';
      this.assistant = '';
      this.value1 = '';
      this.value2 = '';
      this.value3 = '';
      this.value4 = '';
      this.make = '';
      this.content_remark = '';
      this.design = '';
      this.currentPage1 = 1;
      this.score_time_one = ''

      this.angleValue = ''
      this.viewValue = ''
      this.buildingTypeValue = ''
      this.projectAreaValue = ''
      this.indoorTypeValue = ''
      this.score = ''
      this.orField = ''
      this.orWhere = ''
      if (this.$refs.sortTable) {
        this.$refs.sortTable.clearSort();
      }
      indexApi().then(res => {
        this.imgArr = res.data;
        this.total = res.total;
        this.paginationInput = res.limit;
        this.focusDiyIpt = false;
        this.loading = false
      })
      scorelistApi(
          {site: 1}
      ).then(res => {
        this.imgArr_evt = res.data
        this.USer = res.user
        this.Avg = res.average
        this.focusDiyIpt = false;
      });

      StaffscoreApi(
          {site: 1}
      ).then(res => {
        this.imgArr_two = res.data
        this.USer_two = res.user
        this.focusDiyIpt = false;

        this.Avg_two = {
          count: res.count,
          average: res.average,
          score_count: res.score_count
        };
      });
    }
  },

};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@import url("../../style/Work_management.less");
@import url("../../assets/js/flex-images.css");

.el-main {
  left: 175px;
  /* 与左侧项目管理列表的宽度保持一致 */
  padding: 0px;
  /* 添加一些内边距，使内容不紧贴在边缘 */
  top: 60px;
  position: relative;
}


.edit {
  // width: 1000px;

  display: flex;

  div {
    height: 26px;
    cursor: pointer;
  }

  .el-input {
    height: 26px;
    line-height: 26px;
    cursor: pointer;
    margin-left: 5px;
  }

  span {

    height: 26px;
    font-size: 12px;
    line-height: 26px;
    color: #589ff9;
    border-radius: 3px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /deep/ .el-input__inner {
    height: 26px;
    line-height: 26px;
    cursor: pointer;
    font-size: 12px;
    padding-left: 10px;
    border: 1px solid #888a8f;
  }

  /deep/ .el-input__icon {
    line-height: 0px;
  }
}

.view_box {
  display: flex;
  justify-content: end;

  .shangchuan {
    font-size: 12px;
    border: 1px solid #e5e5e5;
    border-radius: 3px;
    height: 28px;
    line-height: 28px;
    padding: 0 10px;
    cursor: pointer;
  }

  .el-dropdown {
    margin-top: 5px;
    margin-right: 10px;
    margin-left: 10px;
  }

  span {
    border: 1px solid #e5e5e5;
    border-radius: 3px;
    font-size: 14px;
    padding: 4px 10px;
  }
}

.content {
}


.Mapping_quantity {
  width: 100%;
  margin-top: 10px;
  background: #fff;

}

.image-container {

}

.img_one {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  width: 350px;
  // margin: 0  5px 0px 5px;
  transition: all 0.5s ease;
  overflow: hidden;
}

.img_one img:hover {
  transform: scale(1.02);
  cursor: pointer;
}

.img_two {
  width: 355px;
  height: 220px;
  margin: auto;
  display: flex;
  background-color: #e3e3e3;
  transition: all 0.5s ease;
}

.img_two img:hover {
  transform: scale(1.01);
  cursor: pointer;
}

.flex-images {
  margin-top: 20px;
  // margin-bottom: 17px;
  // margin:0  10px  40px  10px;
  display: flex;

  .item {
    grid-template-columns: repeat(3, 1fr); /* 定义3列，每列宽度相等 */
    grid-gap: 20px; /* 定义网格间距 */
  }

  img {
    // object-fit: cover;
  }

  div {
    font-size: 12px;
    text-align: left;
  }
}


/deep/ .flex-images {
  width: 100%;
  overflow-y: scroll !important;
  height: 89.5vh;
  display: flex;
  flex-wrap: wrap;
  // display: grid;
  // grid-template-columns: 1fr 1fr 1fr 1fr 1fr  1fr;
  // grid-template-rows: 1fr 1fr;
}

.img-box {
  background: #fff;
}

.img-box .item {
  position: relative;
  display: flex !important;
  justify-content: center;
  border: none;
}

.img-box .item img {
  width: 100%;
  object-fit: contain;
}

.item_one {
  position: relative;
  // display: flex !important;
  // justify-content: center;
  border: none;
}


.select {
  position: absolute;
  right: -20px;
  top: -25px;
  width: 0;
  height: 0;
  border: 25px solid;
  border-color: transparent #409eff transparent transparent;
  transform: rotate(135deg);
  color: #fff;
}

.select1 {
  position: absolute;
  left: 10px;
  top: 9px;
  width: 36px;
  height: 24px;
  color: #fff;
  background: #dd127b;
  border-radius: 6px;
  line-height: 24px;
  text-align: center;
  font-size: 12px;
}

.el-icon-check {
  position: absolute;
  font-size: 18px;
  top: -9px;
  left: 5px;
  transform: rotate(223deg);
}

.image-container {
  position: relative;
}

.prev-button {
  position: absolute;
  left: 0;
  top: 0%;
  height: 800px;
  width: 300px;
  opacity: 0;
  z-index: 999;
}

.prev-button:hover {
  cursor: url("../../images/left.png"), auto;

}

.next-button {
  position: absolute;
  right: 550px;
  top: 0%;
  height: 800px;
  width: 300px;
  opacity: 0;
}

.next-button:hover {
  cursor: url("../../images/right.png"), auto;
}

/deep/ .el-select-dropdown__item span {
  width: 150px !important;
}

.dialogEvt /deep/ .el-dialog {
  background-color: #d5d5d5 !important;
}

.dialogEvt {
  overflow: hidden !important;
}


.right_top {
  position: absolute;
  width: 120px;
  right: 5px;
  top: 1px;
  height: 80px;
  cursor: pointer;
}

.left_top {
  width: 18px;
  position: absolute;
  top: 10px;
  left: 12px;
  height: 18px;
  background-color: #fff;
  border-radius: 50%;
}

.left_top_2 {
  width: 18px;
  position: absolute;
  top: 10px;
  left: 12px;
  height: 18px;
  background-color: #e71717;
  border-radius: 50%;
  border: 3px solid #fff;
}

.left_top_3 {
  width: 18px;
  position: absolute;
  top: 10px;
  left: 12px;
  height: 18px;
  background-color: #3e77f3;
  border-radius: 50%;
  border: 3px solid #fff;
}

.right_bottom {
  position: absolute;
  width: 120px;
  right: 5px;
  bottom: 32px;
  height: 80px;
}

.right_bottom:hover {
  // cursor: url("../../images/magnifier.png"),auto;
}

/deep/ .el-tooltip__popper.is-dark {
  background-color: #409eff !important;
}

.selectEvt {
  width: 380px !important;
}


input[type="checkbox"].checkbox1 {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  display: inline-block;
  position: relative;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1px solid #d6d3d3;
}

input[type="checkbox"].checkbox2 {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  display: inline-block;
  position: relative;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1px solid #d6d3d3;
}

input[type="checkbox"].checkbox3 {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  display: inline-block;
  position: relative;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1px solid #d6d3d3;
}

input[type="checkbox"].checkbox1:checked::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: blue; /* 第一个复选框点击后的效果为蓝色 */
}

input[type="checkbox"].checkbox2:checked::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: rgb(104, 102, 102); /* 第二个复选框点击后的效果为红色 */
}

/deep/ .sousuo {
  margin: 90px 0 0 325px !important;
  width: 1500px;
}

/deep/ .sousuo .el-input--suffix .el-input__inner {
  border-radius: 6px !important;
}

.bor_box {
  border-radius: 6px !important;

}

placeholder {
  color: #f00;
}

/deep/ .vip .el-input__inner {
  background-color: #589ff9 !important;
  color: #fff !important;
}


/deep/ .your-css-class {
  background-color: #589ff9 !important;
  color: #fff !important;
}

/deep/ ::placeholder {
  color: #e5e5e5;
}

/deep/ .sousuo .el-dialog__body {
  font-size: 13px !important;
}

/deep/ .searchLabel {
  overflow: hidden;
}

.tag-container {
  display: flex;

}

.main-category {
  display: flex;
  flex-direction: column;
  /* 让子元素（标题、选项）基于同一基准对齐 */
  align-items: flex-start;
}

.category-title {
  font-weight: bold;
  margin-bottom: 8px;
  font-size: 12px;
  margin-left: 20px;
  width: 50px;
}

.category-title_one {
  font-weight: bold;
  margin-bottom: 8px;
  font-size: 12px;
  margin-left: 10px;
  width: 50px;
}

.sub-item {
  display: flex;
  align-items: center;
  /* 继承父容器的对齐，保证和标题统一 */
  align-self: flex-start;
  margin-bottom: 6px;
  cursor: pointer;
  border-radius: 4px; /* 可选，让边框更圆润 */
  padding: 4px 5px; /* 可选，调整内边距，避免内容挤压 */
  min-width: 80px;
}

/* 绿色标记点：预占空间 + 选中变色 */
.dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border: 1px solid transparent; /* 未选中时透明边框 */
  background-color: transparent; /* 未选中时透明背景 */
  margin-right: 6px;
  flex-shrink: 0; /* 防止压缩，保证占位空间 */
}

.dot.active {
  background-color: green; /* 选中时显示绿色背景 */
  border-color: green; /* 选中时显示绿色边框 */
}


.dot_one {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border: 1px solid transparent; /* 未选中时透明边框 */
  background-color: transparent; /* 未选中时透明背景 */
  margin-right: 6px;
  flex-shrink: 0; /* 防止压缩，保证占位空间 */
  transition: all 0.2s ease; /* 平滑过渡效果 */
}

/* 基础样式 */
.dot_one {
  /* 未激活状态的基础样式 */
  width: 12px;
  height: 12px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 6px;
  border: 1px solid transparent; /* 预定义边框，避免激活时跳动 */
}

/* 激活状态的基础样式 */
.dot_one.active {
  border-width: 1px; /* 激活时显示边框 */
}

/* 基础样式 */
.dot_one {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 6px;
  border: 1px solid transparent;
  background-color: transparent; /* 默认透明（白色背景下看起来是白色） */
}

/* 激活状态的基础样式 */
.dot_one.active {
  border-width: 1px;
}

/* 绿色标签样式 */
.dot_one.green.active {
  background-color: #4CAF50;
  border-color: #4CAF50;
}

/* 灰色标签样式 */
.dot_one.gray.active {
  background-color: #9E9E9E;
  border-color: #9E9E9E;
}

/* 手动选择的标签样式 */
.dot_one.active:not(.green):not(.gray) {
  background-color: #4CAF50;
  border-color: #4CAF50;
}


.text {
  flex-shrink: 0; /* 文字不压缩 */
}

.no-children {
  cursor: default;
  opacity: 0.6;
  pointer-events: none; /* 禁止点击（可选） */
}

/* 新增鼠标悬停样式 */
.sub-item:hover {
  background-color: #D8D8D8; /* 自定义背景色 */
  color: #000;
}

/deep/ .el-form-item__label {
  font-size: 12px !important;
}


.button_on {
  padding: 7px 20px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 12px;
}

.tga_score /deep/ .el-select__tags {
  height: 30px !important;
  overflow: hidden !important;
}

.tga_score /deep/ .el-tag.el-tag--info {
  background-color: #589ff9 !important;
  border: 1px solid #e3e3e3 !important;
  height: 24px !important;
  overflow: hidden;
  color: #fff !important;
}


@media screen and (min-width: 0px) and (max-width: 1920px) {
  .shanchu {
    margin-top: 20px !important;
  }

  .img_day_header img {
    width: 1300px !important;
    height: 800px !important;
  }

  .tag-container {
    margin-top: 40px !important;
  }

  /deep/ .searchLabel_one {
    width: 30% !important;

    .tag_one {
      margin: 10px 0 !important
    }
  }

  .next-button {
    height: 800px !important;
    right: 450px !important;
  }

}

@media screen and (min-width: 1921px) and (max-width: 2560px) {
  .img_day {
    height: 1000px !important;
  }

  .img_day_header {
    height: 1000px !important;

    img {
      height: 1000px !important;
      width: 1500px !important;
    }

    .img_day_bottom {
      height: 777px !important;
    }
  }

  .tag-container {
    margin-top: 80px !important;
  }

  /deep/ .searchLabel {
    width: 2000px !important;
  }

  .prev-button {
    height: 1000px !important;
  }

  .next-button {
    height: 1000px !important;
    right: 450px !important;
  }
}

@media screen and (min-width: 2561px) and (max-width: 3440px) {
  .img_day {
    height: 1000px !important;
  }

  .img_day_header {
    height: 1000px !important;

    img {
      height: 1000px !important;
      width: 1500px !important;
    }

    .img_day_bottom {
      height: 777px !important;
    }
  }

  .tag-container {
    margin-top: 80px !important;
  }

  /deep/ .searchLabel {
    width: 2000px !important;
  }

  .prev-button {
    height: 1000px !important;
  }

  .next-button {
    height: 1000px !important;
    right: 450px !important;
  }

  /deep/ .searchLabel_one {
    width: 17% !important;

    .tag_one {
      margin: 70px 0 !important
    }
  }
}

@media screen and (min-width: 3441px) and (max-width: 3840px) {
  .img_day {
    height: 1000px !important;
  }

  .img_day_header {
    height: 1000px !important;

    img {
      height: 1000px !important;
      width: 1500px !important;
    }

    .img_day_bottom {
      height: 777px !important;
    }
  }

  .tag-container {
    margin-top: 80px !important;
  }

  /deep/ .searchLabel {
    width: 2000px !important;
  }

  .prev-button {
    height: 1000px !important;
  }

  .next-button {
    height: 1000px !important;
    right: 450px !important;
  }

  /deep/ .searchLabel_one {
    width: 17% !important;

    .tag_one {
      margin: 70px 0 !important
    }
  }
}


.form_evt /deep/ .el-form-item {
  margin-bottom: 10px !important;
}

.form_evt /deep/ .el-form-item__label {
  text-align: left !important;
  text-indent: 20px;
}

.form_one /deep/ .el-form-item__label {
  text-align: left !important;
  text-indent: 20px;
}

.filter-btn {
  width: 80px;
  height: 25px;
  cursor: pointer;
  display: flex;
  border: 1px solid #589ff9;
  margin-left: 10px;
  justify-content: center;
  border-radius: 5px;
  background-color: white;
  transition: background-color 0.3s ease;
}

.filter-btn span {
  font-size: 14px;
  transition: color 0.3s ease;
}

.filter-btn:hover {
  background-color: #589ff9;
}

.filter-btn:hover span {
  color: white;
}


.upload-btn {
  width: 63px;
  background-color: #589ff9;
  cursor: pointer; /* 添加上手型指针，提示可点击 */
  display: inline-flex; /* 确保宽度生效 */
  align-items: center; /* 图片居中对齐 */
  justify-content: center; /* 图片居中对齐 */
  transition: background-color 0.3s ease; /* 平滑过渡效果 */
  padding: 3px 0; /* 适当增加内边距，让点击区域更大 */
}

.upload-btn:hover {
  background-color: white;
  border: 1px solid #589ff9; /* 可选：悬停时添加边框，保持整体大小一致 */
}

.upload-btn img {
  width: 15px;
  height: 15px;
}

.hover-text:hover {
  color: #589ff9 !important; /* 使用important确保覆盖其他样式 */
  cursor: pointer; /* 可选：添加指针效果提示可交互 */
}

</style>
<style>
.el-tooltip__popper.is-dark {
  background-color: #589ff9 !important;
}

.el-tooltip__popper .popper__arrow {
  display: none !important;
}

.searchLabel .el-dialog__header {
  padding: 0px !important;
}

.your-css-class input {
  background-color: #589ff9;
  color: #fff !important;
}
</style>



// WEBPACK FOOTER //
// src/src/Work_management/index.vue